import { metaAccount } from '@/router/meta-config'
const permissionKey = 'DICTIONARY'
// ACTIONS_DICTIONARY

export default [
  {
    path: '/actions-dictionary',
    name: 'page-actions-dictionary',
    component: () => import('@/pages/actionsDictionary'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
